import { render, staticRenderFns } from "./DsioUserPos.vue?vue&type=template&id=5f0b62a3&"
import script from "./DsioUserPos.vue?vue&type=script&lang=js&"
export * from "./DsioUserPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0b62a3')) {
      api.createRecord('5f0b62a3', component.options)
    } else {
      api.reload('5f0b62a3', component.options)
    }
    module.hot.accept("./DsioUserPos.vue?vue&type=template&id=5f0b62a3&", function () {
      api.rerender('5f0b62a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioUserPos.vue"
export default component.exports